"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fullscript = void 0;

var _client = require("./client");

var _eventSystem = require("./eventSystem");

var _fullscriptJsValidator = require("./fullscriptJsValidator");

var Fullscript = options => {
  (0, _fullscriptJsValidator.validateFullscriptOptions)(options);
  var eventDispatcher = (0, _eventSystem.createDispatcher)();
  (0, _eventSystem.initializeMessageListener)(options, eventDispatcher);
  return (0, _client.createClient)(options, eventDispatcher);
};

exports.Fullscript = Fullscript;